module.exports = __webpack_public_path__ + "assets/images/survey-banner-mobile.svg?v=7520e2a4";